/**
 * Runtime reader for CSS custom properties from design-tokens.css.
 * NOT a second colour palette — do not store hex here.
 *
 * Edit colours in: src/styles/design-tokens.css
 * Use `var(--ajw-*)` in CSS/inline styles when the browser can resolve them.
 * Use `getCssToken("--ajw-purple")` for Chart.js / canvas (needs resolved colour).
 */

export const getCssToken = (tokenName: string): string => {
  const name = tokenName.startsWith("--") ? tokenName : `--${tokenName}`;
  if (typeof document === "undefined" || !document.documentElement) {
    return "";
  }
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
};

/** Convenience accessors that always read from design-tokens.css at call time. */
export const BRAND_COLORS = {
  get ajwPurple() {
    return getCssToken("--ajw-purple");
  },
  get ajwBlue() {
    return getCssToken("--ajw-blue");
  },
  get ajwGrey() {
    return getCssToken("--ajw-grey");
  },
  get ajwRed() {
    return getCssToken("--ajw-red");
  },
  get silverGrey() {
    return getCssToken("--silver-grey");
  },
  get jetstreamPurple() {
    return getCssToken("--jetstream-purple");
  },
  get jetstreamBridge() {
    return getCssToken("--jetstream-bridge");
  },
  get ajwPurpleDark() {
    return getCssToken("--ajw-purple-dark");
  },
};
